<template>
    <div class="content-section active" id="edu-appointment">
        <div class="admin-header">
            <div>
                <h1 class="admin-title">教育产品预约管理</h1>
                <p>管理用户提交的教育产品体验预约申请</p>
            </div>
            <div class="admin-actions">
                <button class="admin-btn secondary" @click="eduOutRecord">
                    <i class="fas fa-file-export"></i> 导出数据
                </button>
                <button class="admin-btn" @click="eduAddRecord">
                    <i class="fas fa-plus"></i> 添加记录
                </button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="data-table-container">
            <div class="table-controls">
                <div class="search-box">
                    <i class="fas fa-search"></i>
                    <input type="text"
                           id="search-input"
                           @input="handleSearch"
                           placeholder="搜索姓名、学校或联系方式..."
                           v-model="searchText">
                </div>
                <div class="filters">
                    <select class="filter-select" v-model="filters.status">
                        <option value="all">所有状态</option>
                        <option value="create">待处理</option>
                        <option value="contacted">已联系</option>
                        <option value="rejected">已拒绝</option>
                    </select>
                    <select class="filter-select" v-model="filters.userType">
                        <option value="all">所有用户类型</option>
                        <option value="teacher">教师</option>
                        <option value="psychologist">心理老师</option>
                        <option value="administrator">学校管理者</option>
                        <option value="parent">家长</option>
                        <option value="other">其他</option>
                    </select>
                    <select class="filter-select" v-model="filters.date">
                        <option value="30">最近30天</option>
                        <option value="7">最近7天</option>
                        <option value="1">今日</option>
                    </select>
                </div>
            </div>

            <table class="data-table">
                <thead>
                    <tr>
                        <th>申请人</th>
                        <th>学校/机构</th>
                        <th>职位</th>
                        <th>联系方式</th>
                        <th>兴趣模块</th>
                        <th>申请时间</th>
                        <th>状态</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredAppointments"
                        :key="item.id"
                        :data-id="item.id"
                        :data-type="item.position"
                        :data-status="item.state"
                        :data-date="item.date">
                        <td>
                            <div class="user-info">
                                <div class="user-avatar">{{ item.name.charAt(0) }}</div>
                                <div>
                                    <div class="user-name">{{ item.name }}</div>
                                </div>
                            </div>
                        </td>
                        <td>{{ item.organization }}</td>
                        <td class="connect-info">{{ item.position }}</td>
                        <td>
                            <div class="connect-info">{{ item.phone }}</div>
                            <div class="connect-info">{{ item.email }}</div>
                        </td>
                        <td>{{getIntestText(item.interest)}}</td>
                        <td class="connect-info">{{ item.submit_time }}</td>
                        <td>
                            <span :class="['status-badge', item.state]">
                                {{ getStatusText(item.state) }}
                            </span>
                        </td>
                        <td>
                            <button class="action-btn view-detail-btn" @click="viewDetail(item)">
                                <i class="fas fa-eye"></i> 查看
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 分页 -->
            <div class="pagination">
                <button class="pagination-btn"
                        :disabled="currentPage === 1"
                        @click="prevPage">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <button v-for="page in totalPages"
                        :key="page"
                        class="pagination-btn"
                        :class="{ active: currentPage === page }"
                        @click="goToPage(page)">
                    {{ page }}
                </button>
                <button class="pagination-btn"
                        :disabled="currentPage === totalPages"
                        @click="nextPage">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { exportToCSV } from '../../../../csvExport.js';
import axios from 'axios';
    import { EventBus } from '@/eventBus.js';

export default {
    name: 'EduAppointment',

  data() {
      return {
          timeout_fd:null,
      searchText: '',
      filters: {
        status: 'all',
        userType: 'all',
        date: '30'
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 42,
      appointments: [
        {
          id: 1,
          name: '张老师',
              organization: '北京市第一中学',
          position: '教师',
          phone: '138****1234',
          email: 'zhang@school.com',
          interest: '教师功能',
          submit_time: '2025-06-18 14:30',
          state: 'contacted',
              resvType: 'teacher',
          date: '2025-06-18'
        },
        {
          id: 2,
          name: '李女士',
            organization: '阳光小学',
          position: '家长',
          phone: '139****5678',
          email: 'li@example.com',
          interest: '家长功能',
          submit_time: '2025-06-17 10:15',
            state: 'create',
            resvType: 'parent',
          date: '2025-06-17'
        },
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    filteredAppointments() {
        let filtered = this.appointments;
      
        /*// 搜索过滤
        if (this.searchText) {
            const search = this.searchText.toLowerCase();
            filtered = filtered.filter(item => 
                item.name.toLowerCase().includes(search) ||
                item.organization.toLowerCase().includes(search) ||
                item.phone.includes(search) ||
                item.email.toLowerCase().includes(search)
            );
        }*/
      
        // 状态过滤
        if (this.filters.status !== 'all') {
            filtered = filtered.filter(item => item.status === this.filters.status);
        }
      
        // 用户类型过滤
        if (this.filters.userType !== 'all') {
            filtered = filtered.filter(item => item.resvType === this.filters.userType);
        }

        // 时间过滤
        if (this.filters.date !== '30') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            filtered = filtered.filter(item => {
                const itemDate = new Date(item.submit_time);
                if (this.filters.date === '1') { // Today
                    return itemDate.toDateString() === today.toDateString();
                } else if (this.filters.date === '7') { // Last 7 days
                    const sevenDaysAgo = new Date(today);
                    sevenDaysAgo.setDate(today.getDate() - 6);
                    return itemDate >= sevenDaysAgo && itemDate <= today;
                }
                return true;
            });
        }
      return filtered;
    }
        },
        created() {
            this.resetParam();
            this.getEduList();
        },
        mounted() {
            EventBus.$on('freshEduList', () => {
                this.getEduList();
            });
        },
        beforeDestroy() {
            EventBus.$off('freshEduList');
        },
        methods: {
            getIntestText(intest) {
                if (!intest || intest.length == 0) {
                    return "";
                }
                const intestList = intest.split(",");
                const eduInterestMap = {
                    'teacher': '教师功能',
                    'student': '学生功能',
                    'parent': '家长功能',
                    'all': '全部功能'
                };

                const translatedList = intestList.map(item => {
                    const trimmedItem = item.trim();
                    return eduInterestMap[trimmedItem] || trimmedItem;
                });

                return translatedList.join("  ") || intest;
            },
            handleSearch() {
                clearTimeout(this.timeout_fd);
                this.timeout_fd = setTimeout(() => {
                    if (this.searchText.length > 0) {
                        this.getSearchList();
                    } else {
                        this.getEduList();
                    }
                }, 1000);
            },
            resetParam() {
                this.appointments = [];
                this.searchText= '',
                this.filters= {
                    status: 'all',
                    userType: 'all',
                    date: '30'
                }
                this.currentPage = 1;
                this.totalItems = 0;
            },
            async getSearchList() {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');
                try {
                    const payload = {
                        resvType: "edu",
                        curpage: this.currentPage,
                        search: this.searchText,
                    };
                    const response = await axios.post('/api/reservation/search', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }
                    console.log(response.data.infos);
                    this.appointments = response.data.infos;
                    this.totalItems = response.data.total;
                } catch (error) {
                    console.error(' failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            async getEduList() {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');
                try {
                    const payload = {
                        resvType:"edu",
                        curpage: this.currentPage,
                    };
                    const response = await axios.post('/api/reservation/list', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }
                    console.log(response.data.infos);
                    this.appointments = response.data.infos;
                    this.totalItems = response.data.total;
                } catch (error) {
                    console.error(' failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            eduOutRecord() {
                const headers = [
                    '申请人', '学校/机构', '职位', '联系电话', '电子邮箱',
                    '兴趣模块', '申请时间', '状态'
                ];

                const exportData = this.filteredAppointments.map(item => ({
                    '申请人': item.name || '',
                    '学校/机构': item.organization || '',
                    '职位': item.position || '',
                    '联系电话': item.phone || '',
                    '电子邮箱': item.email || '',
                    '兴趣模块': item.interest || '',
                    '申请时间': item.submit_time || '',
                    '状态': this.getStatusText(item.state) || ''
                }));

                exportToCSV(headers, exportData, '教育预约数据');
            },
            eduAddRecord() {
                this.$emit('show-add-user');
            },
            getStatusText(status) {
              const statusMap = {
                'create': '待处理',
                'contacted': '已联系',
                'rejected': '已拒绝'
              };
              return statusMap[status] || status;
            },
            viewDetail(item) {
              this.$emit('view-detail', item);
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    if (this.searchText.length > 0) {
                        this.getSearchList();
                    } else {
                        this.getEduList();
                    }
                } 
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    if (this.searchText.length > 0) {
                        this.getSearchList();
                    } else {
                        this.getEduList();
                    }
                }
            },
            goToPage(page) {
                if (this.currentPage == page) {
                    return;
                }
                this.currentPage = page;
                if (this.searchText.length > 0) {
                    this.getSearchList();
                } else {
                    this.getEduList();
                }
            }
  }
}
</script>